module.exports = __webpack_public_path__ + "static/media/maintenance-icon.270cac2c.svg";